<template>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li v-for="(b, i) in breadcrumbsList" :key="i" class="breadcrumb-item">
                <span @click="navigateTo(i)" :class="{ linked: !!b.link }">
                    {{ b.name }}
                </span>
            </li>
        </ol>
    </div>
</template>
<script>
export default {
    name: 'breadcrumbs',
    data () {
        return {
            breadcrumbsList: []
        }
    },
    watch: {
        '$route' () {
            this.breadcrumbsList = this.$route.meta.breadcrumb
        }
    },
    methods: {
        navigateTo (i) {
            if (this.breadcrumbsList[i].link) this.$router.push(this.breadcrumbsList[i].link)
        }
    }
}
</script>
<style lang="scss" scoped>
.linked {
    cursor: pointer;
    color: #007bff;
}
</style>
